<template>
  <div class="my-loads">
    <div class="my-loads__tools">
      <MyLoadsFiltersAdvance
        :active="activeFilters"
        :data="filtersSelectedStorage"
        @changeStatusFilters="changeStatusFilters"
        @selectedFilters="applyFilters"
        @resetFilters="resetFilters"
      ></MyLoadsFiltersAdvance>
      <AddColumnsGrid
        :active="activeColumns"
        :data="columnsSelectedStorage"
        :type="'myLoad'"
        @changeStatusColumns="changeStatusColumns"
        @addColumns="applyColumns"
      ></AddColumnsGrid>
      <div class="export-button" @click="exportData()">
        <i v-b-popover.hover.top="'Export'">
          <i v-if="!loadingExport" class="el-icon-download"></i>
          <b-spinner v-if="loadingExport" variant="primary" font-scale="1"></b-spinner>
        </i>
      </div>
    </div>
    <div class="my-loads__loading">
      <div class="loading loading__height" v-if="loadingItems || loadingItemsCopy">
        <b-icon icon="truck" animation="cylon" font-scale="3"></b-icon>
        <FadeAnimationTextArray :textArray="loadingTextArray" />
      </div>
    </div>
    <div class="my-loads__table" @click="inactiveTools()">
      <el-table
        :data="tableData"
        :height="tableHeight"
        style="width: 100%"
        ref="el-table"
        @cell-mouse-enter="onCellMouseEnter"
        @cell-mouse-leave="onCellMouseLeave"
        @row-click="onSelectionChanged"
        @sort-change="onSortChanged"
      >
        <el-table-column
          v-for="col in columnFields"
          :key="col.field"
          :prop="col.field"
          :label="col.label"
          :fixed="col.fixed"
          :min-width="col.minWidth"
          :sortable="col.sortable"
        >
          <template #default="scope">
            <div v-if="col.field === 'name'">
              <div>
                <LoadSHP :params="scope.row" />
              </div>
            </div>
            <div v-else-if="col.field === 'load_status'">
              <LoadStatus :params="scope" />
            </div>
            <div v-else-if="col.field === 'included_accessorials'">
              <LoadAccesorials :params="scope.row.included_accessorials" />
            </div>
            <div v-else-if="col.field === 'expected_ship_date'">
              <LoadDateExpectedEpd :params="scope.row" />
            </div>
            <div v-else-if="col.field === 'expected_delivery_date'">
              <LoadDateExpectedEdd :params="scope.row" />
            </div>
            <div v-else-if="col.field === 'revenue_cost'">
              <LoadRevenueCost :params="scope.row" />
            </div>
            <div v-else-if="col.field === 'pro_number'">
              <LoadProNumber :params="scope.row" />
            </div>
            <div v-else-if="col.field === 'created_date'">
              <LoadDates :params="scope.row.created_date" />
            </div>
            <div v-else>
               {{
                (col.field === "carrier" || col.field === "customer") &&
                (scope.row.carrier || scope.row.customer)
                  ? (scope.row[col.field] && scope.row[col.field].name)
                  : scope.row[col.field]
              }}

            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <Test /> -->
    <div class="my-loads__not-found" v-if="notFound">
      <i class="ion ion-file-tray-outline my-loads__not-found__icon"></i>
      <p>No loads were found.</p>
    </div>
  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import XLSX from "xlsx/xlsx";
import { mapGetters } from "vuex";
import onResize from "@/Extend/onResize";
import LoadStatus from "@/components/CellRendered/LoadStatus.vue";
import LoadDateExpectedEpd from "@/components/CellRendered/LoadDateExpectedEpd.vue";
import LoadDateExpectedEdd from "@/components/CellRendered/LoadDateExpectedEdd.vue";
import LoadDates from "@/components/CellRendered/LoadDates.vue";
import LoadRevenueCost from "@/components/CellRendered/LoadRevenueCost.vue";
import LoadAccesorials from "@/components/CellRendered/LoadAccesorials.vue";
import LoadProNumber from "@/components/CellRendered/LoadProNumber.vue";
import LoadSHP from "@/components/CellRendered/LoadSHP.vue";
import CustomerCell from "@/components/CellRendered/Customer.vue";
import MyLoadsFiltersAdvance from "@/components/MyLoadsFiltersAdvance.vue";
import AddColumnsGrid from "@/components/AddColumnsGrid.vue";
import LoadStatusType from "../../Extend/LoadStatusType";
import FadeAnimationTextArray from "../../components/FadeAnimationTextArray.vue";
import LoadingTextArray from "../../utils/LoadingTextArray";

export default {
  name: "my-load-v2",
  mixins: [LoadStatusType, onResize],
  components: {
    LoadStatus,
    LoadDateExpectedEpd,
    LoadDateExpectedEdd,
    LoadDates,
    LoadRevenueCost,
    FadeAnimationTextArray,
    MyLoadsFiltersAdvance,
    LoadAccesorials,
    LoadSHP,
    LoadProNumber,
    AddColumnsGrid,
    CustomerCell,
  },
  props: {
    rowLoads: {
      type: Array,
    },
    limit: Number,
    perPage: Number,
    firstItemsLoaded: Boolean,
    loadingItems: Boolean,
    filters: Object,
    filtersFromDashboard: Boolean,
  },
  data() {
    return {
      tableData: [],
      columnsSelectedStorage: [],
      filtersSelectedStorage: null,
      searchQuery: "",
      loadingItemsCopy: false,
      loadingTextArray: LoadingTextArray.myLoads,
      arrayFilteredRows: [],
      activeFilters: false,
      activeColumns: false,
      dataFilters: null,
      scrollNumber: 0,
      loadingData: false,
      notFound: false,
      pageSelector: 0,
      activeExport: false,
      maxLimit: 119,
      fileName: "My loads",
      filetype: "xlsx",
      sheetName: "sheetname",
      loadingExport: false,
      sort: {
        name: "name",
        load_status: "load_status",
        origin: "origin",
        destination: "destination",
        revenue_cost: "revenue_cost",
        pro_number: "pro_number",
        carrier: "carrier",
      },
      columnsExport: [],
      tableHeight: null,

      columnFields: [
        {
          label: "LOAD NUMBER",
          field: "name",
          field_to_excel: "name",
          minWidth: 140,
          fixed: "left",
          sortable: true,
          sortMethod: this.onSortChanged,
        },
        {
          label: "LOAD STATUS",
          field: "load_status",
          field_to_excel: "load_status",
          minWidth: 140,
          fixed: false,
          sortable: true,
          sortMethod: this.onSortChanged,
        },
        {
          label: "ORIGIN",
          field: "origin",
          field_to_excel: "origin",
          minWidth: 120,
          fixed: false,
          sortable: true,
          sortMethod: this.onSortChanged,
        },
        {
          label: "DESTINATION",
          field: "destination",
          field_to_excel: "destination",
          minWidth: 140,
          fixed: false,
          sortable: true,
          sortMethod: this.onSortChanged,
        },
        {
          label: "TRACKING #",
          field: "pro_number",
          field_to_excel: "pro_number",
          minWidth: 130,
          fixed: false,
          sortable: true,
          sortMethod: this.onSortChanged,
        },
        {
          label: "CARRIER",
          field: "carrier",
          field_to_excel: "carrier",
          minWidth: 120,
          fixed: false,
          sortable: true,
          sortMethod: this.onSortChanged,
        },
        {
          label: "ACCESSORIALS",
          field: "included_accessorials",
          field_to_excel: "included_accessorials",
          minWidth: 120,
          fixed: false,
          sortable: false,
        },
        {
          label: "CREATED DATE",
          field: "created_date",
          field_to_excel: "created_date",
          minWidth: 150,
          fixed: false,
          sortable: false,
        },
        {
          label: "ESTIMATED PICKUP DATE",
          field: "expected_ship_date",
          field_to_excel: "expected_ship_date",
          minWidth: 170,
          fixed: false,
          sortable: false,
        },
        {
          label: "PRICE",
          field: "revenue_cost",
          field_to_excel: "revenue_cost",
          minWidth: 100,
          fixed: false,
          sortable: true,
          sortMethod: this.onSortChanged,
        },
      ],
      // Export Columns
      nameExport: {
        label: "LOAD NUMBER",
        field: "name",
      },
      loadStatusExport: {
        label: "LOAD STATUS",
        field: "load_status",
        dataFormat: this.statusFormat,
      },
      originExport: {
        label: "ORIGIN",
        field: "origin",
      },
      destinationExport: {
        label: "DESTINATION",
        field: "destination",
      },
      proNumberExport: {
        label: "TRACKING #",
        field: "pro_number",
      },
      carrierExport: {
        label: "CARRIER",
        field: "carrier",
        dataFormat: this.carrierFormat,
      },
      customerExport: {
        label: "CUSTOMER",
        field: "customer",
        dataFormat: this.carrierFormat,
      },
      accessorialsExport: {
        label: "ACCESSORIALS",
        field: "included_accessorials",
      },
      createdDateExport: {
        label: "CREATED DATE",
        field: "created_date",
        dataFormat: this.priceFormat,
      },
      shipDateDateExport: {
        label: "PICKUP DATE",
        field: "expected_ship_date",
      },
      revenueCostExport: {
        label: "PRICE",
        field: "revenue_cost",
      },
      dateAPDExport: {
        label: "ACTUAL PICKUP DATE",
        field: "actual_pickup_date",
      },
      dateEDDExport: {
        label: "ESTIMATED DELIVERY DATE",
        field: "expected_delivery_date",
      },
      dateADDExport: {
        label: "ACTUAL DELIVERY DATE",
        field: "actual_delivery_date",
      },
      billingReferenceExport: {
        label: "Billing Reference",
        field: "billing_reference",
      },
      originalColumns: [],
      arrayMyLoads: [],
      columnsSelected: "",
      objectFilters: {
        shp: "",
        origin: "",
        destination: "",
        carrier: "",
        created_date_gt: "",
        created_date_lt: "",
        actual_pickup_date_gt: "",
        actual_pickup_date_lt: "",
        actual_delivery_date_gt: "",
        actual_delivery_date_lt: "",
        expected_ship_date_gt: "",
        expected_ship_date_lt: "",
        expected_delivery_date_gt: "",
        expected_delivery_date_lt: "",
        included_accessorials: "",
        limit: "",
        skip: "",
        order_by: "",
        statuses: [],
        customer: "",
        scrollableTableContainer: null,
      },
      hoveredRow: null,
      selectedRow: null,
      showTooltip: false,
    };
  },
  created() {
    this.loadingData = true;
    this.pageSelector = this.perPage;
    this.rowBuffer = 0;
    this.filtersSelectedStorage = this.filters;
    if (this.rowLoads.length === 0 && !this.loadingItems) {
      this.notFound = true;
    } else {
      this.notFound = false;
    }
    this.loadingData = false;
  },
  async mounted() {
    await this.sleep(0);
    this.tableContainer = document.querySelector(".el-table__body-wrapper");
    this.tableContainerHeight = this.tableContainer.clientHeight;
    this.tableContainer.addEventListener("scroll", this.infiniteScrollHandler);
    this.rowsContainer = document.querySelector(".el-table__body");
    this.filtersAndColumns();
    this.$nextTick(() => {
      this.scrollableTableContainer = document.querySelector(".el-table__body-wrapper");
    });
  },
  computed: {
    ...mapGetters({ isCollapseSidebar: "getCollapseSidebar" }),
  },
  watch: {
    rowLoads() {
      if (this.rowLoads.length !== 0) {
        this.arrayMyLoads = JSON.parse(JSON.stringify(this.rowLoads));
        this.updateData(this.arrayMyLoads);
        this.notFound = false;
      } else {
        this.updateData([]);
        this.notFound = true;
      }
    },
    screenWidth() {
      const clientHeight = window.innerHeight;
      this.tableHeight = clientHeight - 200;
    },
  },
  methods: {
    infiniteScrollHandler() {
      const elementTableHeight = this.rowsContainer.clientHeight;
      const currentScrollPosition = this.tableContainer.scrollTop;
      if (currentScrollPosition + this.tableContainerHeight < elementTableHeight - 20) {
        return;
      }
      this.tableContainer.scrollTop = currentScrollPosition - 30;
      this.$emit("loadMoreItems", this.dataFilters);
    },
    async sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    priceFormat(value) {
      return this.$options.filters.dateFormat(value);
    },
    statusFormat(value) {
      return this.setLoadStatusColor(value).label;
    },
    carrierFormat(value) {
      let carrierName = "";
      if (value != null) {
        carrierName = value.name;
      }
      return carrierName;
    },
    onSortChanged({ prop, order }) {
      if (this.sort[prop]) {
        if (this.dataFilters !== null) {
          this.dataFilters.order_by = `${this.sort[prop]} ${order === 'ascending' ? 'asc' : 'desc'}`;
        } else {
          this.dataFilters = JSON.parse(JSON.stringify(this.objectFilters));
          this.dataFilters.order_by = `${this.sort[prop]} ${order === 'ascending' ? 'asc' : 'desc'}`;
        }
        this.maxLimit = 119;
        this.$emit("loadMoreItemsByFilters", this.dataFilters);
      }
    },
    onSelectionChanged(row, column) {
      if (row && column) {
        if (column.property !== 'name' && column.property !== 'pro_number') {
          this.rowSelected(row);
        }
      }
    },
    rowSelected(data) {
      const loadStatusType = this.setLoadStatusColor(data.load_status);
      let routeName = "";
      if (loadStatusType.label === "Quoted") {
        routeName = "CarriersInfo";
      } else {
        routeName = "LoadsDetails";
      }
      this.$router.push({
        name: routeName,
        params: { loadId: data.id },
      });
      this.$store.commit("load/setSearchText", "");
    },
    resetFilters(data) {
      this.$emit("loadMoreItems", data);
    },
    applyFilters(data) {
      this.dataFilters = data;
      this.notFound = false;
      this.maxLimit = 119;
      if (data === null) {
        this.$emit("loadMoreItems", data);
      } else {
        this.$emit("loadMoreItemsByFilters", data);
      }
      const storageMyLoadTable = {
        filters: this.dataFilters,
        columns: this.columnsSelected,
      };
      if (!this.filtersFromDashboard) {
        localStorage.setItem("my-load-table", JSON.stringify(storageMyLoadTable));
      }
      this.filtersSelectedStorage = this.dataFilters;
    },
    exportData() {
      this.loadingExport = true;
      this.activeColumns = false;
      this.activeFilters = false;
      this.activeExport = true;
      if (this.dataFilters !== null) {
        this.loadMoreItemsWhitFiltersAvances(this.dataFilters);
      } else {
        this.loadMoreItemsWhitFiltersAvances(this.objectFilters);
      }
    },
    exportExcel(data) {
      const createXLSLFormatObj = [];
      const newXlsHeader = [];
      const vm = this;
      vm.columnsExport.map((column) => newXlsHeader.push(column.label));
      createXLSLFormatObj.push(newXlsHeader);
      data.map((value) => {
        const innerRowData = [];
        vm.columnsExport.map((val) => {
          let fieldValue = value[val.field];
          if (val.field.split(".").length > 1) {
            fieldValue = this.getNestedValue(value, val.field);
          }
          if (val.dataFormat && typeof val.dataFormat === "function") {
            return innerRowData.push(val.dataFormat(fieldValue));
          }
          return innerRowData.push(fieldValue);
        });
        return createXLSLFormatObj.push(innerRowData);
      });
      const fileName = "My loads.xlsx";
      const wsName = "sheetname";
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
      XLSX.utils.book_append_sheet(wb, ws, wsName);
      XLSX.writeFile(wb, fileName);
      this.loadingExport = false;
    },
    getNestedValue(object, string) {
      const string1 = string.replace(/\[(\w+)\]/g, ".$1");
      const string2 = string1.replace(/^\./, "");
      const a = string2.split(".");
      let objectCopy = object;
      a.forEach((k) => {
        if (k in objectCopy) {
          objectCopy = objectCopy[k];
        }
      });
      return object;
    },
    changeStatusFilters(value) {
      this.activeFilters = value;
      this.activeColumns = false;
    },
    changeStatusColumns(value) {
      this.activeColumns = value;
      this.activeFilters = false;
    },
    applyColumns({ filters, executed }) {
      this.columnsExport = [];
      this.columnsSelected = filters;
      if (!this.originalColumns.length) {
        this.originalColumns = [...this.columnFields];
      }
      const columnsArray = this.validateColumnsSelected(this.columnsSelected);
      this.addColumns(columnsArray, executed);
      this.columnsExport.push(this.nameExport);
      this.columnsExport.push(this.loadStatusExport);
      this.columnsExport.push(this.originExport);
      this.columnsExport.push(this.destinationExport);
      this.columnsExport.push(this.proNumberExport);
      this.columnsExport.push(this.carrierExport);
      this.columnsExport.push(this.accessorialsExport);
      this.columnsExport.push(this.createdDateExport);
      this.columnsExport.push(this.shipDateDateExport);
      this.columnsExport.push(this.revenueCostExport);
      filters.forEach((filter) => {
        if (filter.label.includes("actual_pickup_date")) {
          this.columnsExport.push(this.dateAPDExport);
        }
        if (filter.label.includes("actual_delivery_date")) {
          this.columnsExport.push(this.dateADDExport);
        }
        if (filter.label.includes("expected_delivery_date")) {
          this.columnsExport.push(this.dateEDDExport);
        }
        if (filter.label.includes("customer")) {
          this.columnsExport.push(this.customerExport);
        }
        if (filter.label.includes("billing_reference")) {
          this.columnsExport.push(this.billingReferenceExport);
        }
      });
      if (filters.length !== 0) {
        const storageMyLoadTable = {
          filters: this.dataFilters,
          columns: this.columnsSelected,
        };
        if (!this.filtersFromDashboard) {
          localStorage.setItem("my-load-table", JSON.stringify(storageMyLoadTable));
        }
      }
    },
    validateColumnsSelected(data) {
      if (!data || !data.length) {
        return [];
      }
      const checkedItems = data.filter((item) => item.checked);
      const columnsArray = checkedItems.map((item) => item.text);
      return columnsArray;
    },
    addColumns(columns, executedRefFunction) {
      const fieldMapping = {
        "Actual Pickup Date": "actual_pickup_date",
        "Estimated Delivery Date": "expected_delivery_date",
        "Actual Delivery Date": "actual_delivery_date",
        "Billing Reference": "billing_reference",
        Customer: "customer",
      };
      const newColumns = [
        columns.map((columnName) => {
          const field = fieldMapping[columnName] || columnName.toLowerCase().replace(/\s+/g, "_");
          return {
            label: columnName.toUpperCase(),
            field,
            field_to_excel: field,
            minWidth: field === "expected_delivery_date" ? 200 : 170,
            fixed: false,
            enableCopy: false,
          };
        }),
      ];
      this.columnFields = [...this.originalColumns, ...newColumns[0]];
      if (executedRefFunction) {
        this.reRenderTable();
      }
    },
    reRenderTable() {
      this.$nextTick(() => {
        this.$refs['el-table'].doLayout();
      });
    },

    updateData(data) {
      this.tableData = data;
    },
    filtersAndColumns() {
      const infoLocalStorage = JSON.parse(localStorage.getItem("my-load-table"));
      if (this.filters && infoLocalStorage !== undefined && infoLocalStorage !== null) {
        this.columnsSelectedStorage = infoLocalStorage.columns;
        this.filtersSelectedStorage = this.filters;
        this.dataFilters = this.filters;
        if (this.columnsSelectedStorage !== undefined && this.columnsSelectedStorage !== "") {
          this.applyColumns({ filters: this.columnsSelectedStorage, executed: true });
        } else {
          this.applyColumns({ filters: [], executed: true });
        }
      } else {
        this.applyColumns({ filters: [], executed: true });
      }
    },
    inactiveTools() {
      this.activeFilters = false;
      this.activeColumns = false;
    },
    async loadMoreItemsWhitFiltersAvances(data) {
      this.dataExport = [];
      if (this.$options.filters.checkPermission("get:loads")) {
        const dataFilter = {
          limit: 200,
          skip: 0,
          ...(data.origin && {
            origin: data.origin,
          }),
          ...(data.destination && {
            destination: data.destination,
          }),
          ...(data.statuses &&
            data.statuses.length !== 0 && {
            statuses: data.statuses,
          }),
          ...(data.modes &&
            data.modes.length !== 0 && {
            modes: data.modes,
          }),
          ...(data.accessorial_id && {
            accessorial_id: data.accessorial_id,
          }),
          ...(data.carrier && {
            carrier: data.carrier,
          }),
          ...(data.billing_reference && {
            billing_reference: data.billing_reference,
          }),
          ...(data.created_date_gt && {
            created_date_gt: data.created_date_gt,
          }),
          ...(data.created_date_lt && {
            created_date_lt: data.created_date_lt,
          }),
          ...(data.expected_delivery_date_gt && {
            expected_delivery_date_gt: data.expected_delivery_date_gt,
          }),
          ...(data.expected_delivery_date_lt && {
            expected_delivery_date_lt: data.expected_delivery_date_lt,
          }),
          ...(data.expected_ship_date_gt && {
            expected_ship_date_gt: data.expected_ship_date_gt,
          }),
          ...(data.expected_ship_date_lt && {
            expected_ship_date_lt: data.expected_ship_date_lt,
          }),
          ...(data.actual_delivery_date_gt && {
            actual_delivery_date_gt: data.actual_delivery_date_gt,
          }),
          ...(data.actual_delivery_date_lt && {
            actual_delivery_date_lt: data.actual_delivery_date_lt,
          }),
          ...(data.actual_pickup_date_gt && {
            actual_pickup_date_gt: data.actual_pickup_date_gt,
          }),
          ...(data.actual_pickup_date_lt && {
            actual_pickup_date_lt: data.actual_pickup_date_lt,
          }),
          ...(data.included_accessorials && {
            included_accessorials: data.included_accessorials,
          }),
          ...(data.order_by && {
            order_by: data.order_by,
          }),
        };
        const response = await this.$store.dispatch("load/getLoadsAdvanced", dataFilter);
        if (response.length === 200) {
          this.swal({
            title: "Info",
            text: this.$t("myLoads.exportData"),
            icon: "warning",
          });
          this.exportExcel(response);
        } else {
          this.exportExcel(response);
        }
      }
    },
    onCellMouseEnter(row) {
      this.hoveredRow = this.tableData.indexOf(row);
      this.showTooltip = true;
    },
    onCellMouseLeave(row) {
      this.hoveredRow = this.tableData.indexOf(row);
      this.selectedRow = row;
      this.showTooltip = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../assets/scss/components/Checkboxes.scss";
@use "../../assets/scss/components/Dropdown.scss";
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/table/_tableAccountManagement' as *;

.my-loads {
  width: 100%;
  margin-top: 10px;
  &__tools {
    display: flex;
    justify-content: flex-end;
    margin-right: 5px;
  }
  &__table {
    @include table-design-book(3);
    width: 100%;
    margin: auto;
    margin-top: 10px;
  }
  &__loading {
    position: relative;
    top: 50%;
  }
  &__not-found {
    margin-top: -450px;
    &__icon {
      font-size: 50px;
    }
  }
}
::v-deep {
  .el-table {
  background: transparent;
    &__header {
      th:nth-child(1) {
        display: flex;
        width: 99%;
        margin: auto;
        top: 2px;
        padding-bottom: 8px;
        font-weight: 600;
        font-size: 11px;
        color: $color-primary-company;
        text-align: center;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
        background: #efefef;
        .cell {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    tr {
      background-color: transparent;
      cursor: pointer;
      .gutter {
        display: none !important;
      }
    }
    &__row {
      .el-table__cell {
        background: white;
        text-align: center;
        border-bottom: 1px solid $color-border-container;
        word-break: normal;
      }
    }
  }
}
.export-button {
  border-radius: 5px;
  border: 2px solid var(--color-border-container);
  color: var(--color-primary-company);
  background-color: #efefef;
  padding: 0.1rem 0.4rem;
  font-weight: 600;
  font-size: 17px;
  cursor: pointer;

  &:hover {
    background: var(--color-border-container);
    color: #efefef;
  }
  &:active {
    background: var(--color-border-container);
    color: #efefef;
  }
}
.loading {
  @include loading-overlay;
  background-color: transparent;
  svg,
  p {
    color: $color-primary-company;
  }
}
.cell-wrap-text {
  white-space: normal !important;
}
.expired-date {
  color: red;
}
//CSS for the per page buttons
::v-deep .btn-group,
.btn-group-vertical {
  margin-left: 1px;
}
::v-deep .btn-group .btn {
  border: 2px solid $color-border-container;
  color: $color-primary-company;
  background-color: $color-gray-light;
}
::v-deep .btn-secondary:not(:disabled):not(.disabled).active {
  border: 2px solid $color-border-container;
  border-radius: 5px;
  color: white;
  background-color: $color-border-container;
}
::v-deep .btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-radius: 5px;
  margin-right: 5px;
}
::v-deep .btn-group > .btn:last-child:not(.dropdown-toggle) {
  border-radius: 5px;
}
::v-deep .btn {
  padding: 0.2rem 0.4rem;
  font-weight: 600;
  @include font-small-button-text;
}
::v-deep .spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: -0.125em;
  border: 0.2rem solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite spinner-border;
  animation: 0.75s linear infinite spinner-border;
}
</style>
